





























































































































































import { Vue, Component } from 'vue-property-decorator';
import AMSImg from '@/components/AMSImg.vue';
import { getPrintData } from '@/utils/auth';
import { getOrderPrintData } from '@/api/shipment';

@Component({
  components: {
    'ams-img': AMSImg
  }
})
export default class ShipmentPrint extends Vue {
  orderInfo: any = {};
  // /**打印出库单的数据 */
  // printData: any = {
  //   totalCount: 0,
  //   items: [],
  //   headers: [
  //     { text: '序号', align: 'center', sortable: false, width: '100px' },
  //     { text: '商品', align: 'center', sortable: false },
  //     { text: '容量', align: 'center', sortable: false, width: '100px' },
  //     { text: '数量', align: 'center', sortable: false, width: '100px' }
  //   ],
  //   stockNumber: ''
  // };
  printData: any = {};

  mounted() {
    // const data = getPrintData();
    // if (Object.keys(data).length > 0) {
    //   this.printData = data.data;
    //   this.orderInfo = data.info;
    //   console.log(this.printData);
    //   console.log(this.orderInfo);
    // }
    let id = this.$route.query.id;
    if (id) {
      getOrderPrintData(id).then((data: any) => {
        const d = {
          ...data,
          headers: [
            { text: '序号', align: 'center', sortable: false, width: '100px' },
            { text: '商品', align: 'center', sortable: false },
            { text: '容量', align: 'center', sortable: false, width: '100px' },
            { text: '数量', align: 'center', sortable: false, width: '100px' }
          ]
        };
        this.printData = d;
      });
    }
  }

  /**点击了弹窗里面的打印 */
  onConfimPrintClick() {
    // console.log((this.$refs.printDiv as Element).innerHTML);
    let content: string = this.generateHtml();
    let iframe = document.createElement('iframe');
    iframe.id = 'printIframe';
    iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
    let f = document.body.appendChild(iframe);
    let w = (f.contentWindow || f.contentDocument) as Window;
    let doc = f.contentDocument || f.contentWindow!.document;
    doc.open();
    doc.write(content);
    doc.close();
    iframe.onload = function() {
      w.focus();
      try {
        if (!w.document.execCommand('print', false)) {
          w.print();
        }
      } catch (e) {
        w.print();
      }
      w.close();
      document.body.removeChild(iframe);
    };
  }

  generateHtml(): string {
    let style = this.getStyle();
    let content: string = (this.$refs.printDiv as Element).innerHTML;
    let html = `<head>${style}</head><body>${content}</body>`;
    return html;
  }

  getStyle(): string {
    var str = '',
      styles = document.querySelectorAll('style,link');
    for (var i = 0; i < styles.length; i++) {
      str += styles[i].outerHTML;
    }
    return str;
  }

  /**点击了关闭按钮 */
  onCloseClick() {
    window.close();
  }
}
